import React from 'react';
import { Box, Grid } from '@mui/material';
import { Assignment, Layers, Description, FlashOn, AccessTime, Chat, CalendarToday, Person } from '@mui/icons-material';
import { renderGoalDetails, isBehaviorType, isSkillType, formatDate, getTeacherName } from './utils';
import { InfoItem } from './shared';

const OverviewTab = ({ goalData, teachersForStudent }) => {
  const behavior = isBehaviorType(goalData);
  const skill = isSkillType(goalData);

  return (
    <>
      <Box sx={{ marginBottom: 5, p: 4, backgroundColor: 'white', borderRadius: '16px', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', transition: 'all 0.3s ease', '&:hover': { boxShadow: '0 4px 16px rgba(0,0,0,0.1)' } }}>
        {renderGoalDetails(goalData)}
      </Box>
      <Grid container spacing={4}>
        {goalData?.GoalDetails?.TypeOfGoal?.Type && (
          <InfoItem icon={<Assignment fontSize='small' color='action' />} label='Goal Type' value={goalData?.GoalDetails?.TypeOfGoal?.Type} xs={12} sm={6} />
        )}

        {(behavior ? goalData?.GoalDetails?.TypeOfGoal?.BehaviorType : goalData?.GoalDetails?.TypeOfGoal?.SkillType) && (
          <InfoItem icon={<Layers fontSize='small' color='action' />} label={behavior ? 'Behavior Type' : 'Skill Type'} value={behavior ? goalData?.GoalDetails?.TypeOfGoal?.BehaviorType : goalData?.GoalDetails?.TypeOfGoal?.SkillType} xs={12} sm={6} />
        )}

        {(behavior ? goalData?.GoalDetails?.TypeOfGoal?.Definition : goalData?.GoalDetails?.TypeOfGoal?.SkillDefinition) && (
          <InfoItem icon={<Description fontSize='small' color='action' />} label='Definition' value={behavior ? goalData?.GoalDetails?.TypeOfGoal?.Definition : goalData?.GoalDetails?.TypeOfGoal?.SkillDefinition} xs={12} sm={6} />
        )}

        {behavior && (
          <>
            {goalData?.GoalDetails?.TypeOfGoal?.Onset && (
              <InfoItem icon={<FlashOn fontSize='small' color='action' />} label='Onset' value={goalData?.GoalDetails?.TypeOfGoal?.Onset} xs={12} sm={6} />
            )}
            {goalData?.GoalDetails?.TypeOfGoal?.Offset && (
              <InfoItem icon={<AccessTime fontSize='small' color='action' />} label='Offset' value={goalData?.GoalDetails?.TypeOfGoal?.Offset} xs={12} sm={6} />
            )}
          </>
        )}

        {skill && goalData?.GoalDetails?.TypeOfGoal?.SkillNaturalCue && (
          <InfoItem icon={<Chat fontSize='small' color='action' />} label='Skill Natural Cue' value={goalData?.GoalDetails?.TypeOfGoal?.SkillNaturalCue} xs={12} sm={6} />
        )}

        {formatDate(goalData?.DataCollection?.StartDate || '-') && (
          <InfoItem icon={<CalendarToday fontSize='small' color='action' />} label='Start Date' value={formatDate(goalData?.DataCollection?.StartDate || '-')} xs={12} sm={6} />
        )}

        {formatDate(goalData?.DataCollection?.ByDate) && (
          <InfoItem icon={<CalendarToday fontSize='small' color='action' />} label='Due Date' value={formatDate(goalData?.DataCollection?.ByDate)} xs={12} sm={6} />
        )}

        {getTeacherName(teachersForStudent, goalData?.GoalDetails?.GoalAuthor) && (
          <InfoItem icon={<Person fontSize='small' color='action' />} label='Author' value={getTeacherName(teachersForStudent, goalData?.GoalDetails?.GoalAuthor)} xs={12} sm={6} />
        )}
      </Grid>
    </>
  );
};

export default OverviewTab;


